module.exports = __webpack_public_path__ + "img/heart.24b4e757.svg";